// src/components/OrgPreview/UserNode.js
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { IconUser, IconLayoutDashboard } from '@tabler/icons-react';

/**
 * Custom ReactFlow node for displaying individual users
 * Supports both vertical (TB) and horizontal (LR) layouts via dynamic handle positions
 */
const UserNode = memo(({ data, targetPosition }) => {
    const { email, firstname, lastname, dashboard } = data;
    const fullName = `${firstname} ${lastname}`.trim() || 'Unbekannt';

    // Determine handle position from props (set by Dagre layout) or use default
    const targetPos = targetPosition || Position.Top;

    return (
        <div className="org-user-node">
            {/* Target handle - where edges come in (from parent hierarchy node) */}
            <Handle
                type="target"
                position={targetPos}
                className="org-handle"
            />

            <div className="user-node-content">
                <div className="user-avatar">
                    <IconUser size={16} stroke={1.5} />
                </div>
                <div className="user-info">
                    <span className="user-name">{fullName}</span>
                    <span className="user-email">{email}</span>
                    {dashboard && (
                        <span className="user-dashboard">
                            <IconLayoutDashboard size={12} stroke={1.5} />
                            {dashboard}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
});

UserNode.displayName = 'UserNode';

export default UserNode;
